module.exports = __webpack_public_path__ + "a0c0cafd2cf230bdf868af7ffd8335b3.png";